// Generated by Melange

import * as Buhta_cabinet__Link from "../../html/Link.js";
import * as Buhta_components__Text from "../../../../../../packages/components/src/html/Text.js";
import * as Caml_option from "melange.js/caml_option.js";
import * as Cn from "../../../../../../vendored/classnames/Cn.js";
import * as Curry from "melange.js/curry.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function SidebarNestedItem(Props) {
  let isActive = Props.isActive;
  let route = Props.route;
  let activeIconOpt = Props.activeIcon;
  let iconOpt = Props.icon;
  let title = Props.title;
  const activeIcon = activeIconOpt !== undefined ? Caml_option.valFromOption(activeIconOpt) : null;
  const icon = iconOpt !== undefined ? Caml_option.valFromOption(iconOpt) : null;
  const match = React.useState(function () {
    return false;
  });
  const setHovered = match[1];
  return JsxRuntime.jsxs(Buhta_cabinet__Link.make, {
    route: route,
    className: Cn.fromList({
      hd: "px-6 flex py-1.5 group",
      tl: {
        hd: isActive ? "bg-white/8" : "hover:bg-white/8",
        tl: /* [] */ 0
      }
    }),
    children: [
      isActive || match[0] ? activeIcon : icon,
      JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
        className: Cn.fromList({
          hd: Cn.on("ml-4", icon !== null),
          tl: {
            hd: isActive ? "text-white" : "text-gray-medium group-hover:text-white",
            tl: /* [] */ 0
          }
        }),
        children: title
      })
    ],
    onMouseEnter: (function (param) {
      Curry._1(setHovered, (function (param) {
        return true;
      }));
    }),
    onMouseLeave: (function (param) {
      Curry._1(setHovered, (function (param) {
        return false;
      }));
    })
  });
}

const make = SidebarNestedItem;

export {
  make,
}
/* Buhta_cabinet__Link Not a pure module */
